import {
  LayoutDashboard, CalendarDays, Users, Wallet, UserCog, Scissors,
  Package, Gift, Target, FileBarChart, Settings, Award, Bell, Megaphone, Coins,
} from "lucide-react";

export const NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, perm: "dashboard.read" },
  { to: "/agenda", label: "Agenda", icon: CalendarDays, perm: "agenda.read" },
  { to: "/clienti", label: "Clienti", icon: Users, perm: "clients.read" },
  { to: "/cassa", label: "Cassa", icon: Wallet, perm: "cassa.read" },
  { to: "/team", label: "Team", icon: UserCog, perm: "team.read" },
  { to: "/servizi", label: "Servizi", icon: Scissors, perm: "services.read" },
  { to: "/prodotti", label: "Prodotti / Magazzino", icon: Package, perm: "products.read" },
  { to: "/loyalty", label: "Loyalty", icon: Award, perm: "loyalty.read" },
  { to: "/pacchetti", label: "Pacchetti & Gift Card", icon: Gift, perm: "packages.read" },
  { to: "/notifiche", label: "Centro Notifiche", icon: Bell, perm: "dashboard.read" },
  { to: "/marketing", label: "Marketing", icon: Megaphone, perm: "dashboard.read" },
  { to: "/obiettivi", label: "Obiettivi", icon: Target, perm: "goals.read" },
  { to: "/report", label: "Report", icon: FileBarChart, perm: "reports.read" },
  { to: "/retribuzioni", label: "Retribuzioni", icon: Coins, perm: "payroll.read" },
  { to: "/impostazioni", label: "Impostazioni", icon: Settings, perm: "settings.read" },
];

export const APPT_STATUS = {
  booked: { label: "Prenotato", token: "--hi-appointment-booked" },
  confirmed: { label: "Confermato", token: "--hi-appointment-confirmed" },
  arrived: { label: "Arrivato", token: "--hi-appointment-arrived" },
  in_progress: { label: "In lavorazione", token: "--hi-appointment-inprogress" },
  completed: { label: "Completato", token: "--hi-appointment-completed" },
  cancelled: { label: "Annullato", token: "--hi-appointment-cancelled" },
  no_show: { label: "No-show", token: "--hi-appointment-noshow" },
};

// Stato operativo di avanzamento servizio (workflow rapido in agenda),
// separato dallo stato finanziario (APPT_STATUS).
export const OP_STATUS = {
  waiting: { label: "In attesa", short: "Attesa", token: "--hi-appointment-booked" },
  arrived: { label: "Arrivata", short: "Arrivata", token: "--hi-appointment-arrived" },
  late: { label: "In ritardo", short: "Ritardo", token: "--hi-appointment-noshow" },
  started: { label: "Servizio iniziato", short: "Iniziato", token: "--hi-appointment-inprogress" },
  processing: { label: "In posa", short: "In posa", token: "--hi-gold" },
  ready: { label: "Pronta fase succ.", short: "Pronta", token: "--hi-appointment-confirmed" },
  finished: { label: "Terminata", short: "Terminata", token: "--hi-appointment-completed" },
};
export const OP_STATUS_ORDER = ["waiting", "arrived", "late", "started", "processing", "ready", "finished"];

export const hasPerm = (user, perm) => {
  if (!user) return false;
  const p = user.permissions || [];
  return p.includes("*") || p.includes(perm);
};

// Fase 5.2.2 — Navigazione Admin riorganizzata in macro-menu collassabili.
// Solo pagine ESISTENTI, nessuna duplicazione. Permessi invariati.
export const NAV_GROUPS = [
  { key: "dashboard", label: "Dashboard", icon: LayoutDashboard, to: "/", perm: "dashboard.read" },
  { key: "operativita", label: "Operatività", icon: CalendarDays, children: [
    { to: "/agenda", label: "Agenda", perm: "agenda.read" },
    { to: "/cassa", label: "Cassa", perm: "cassa.read" },
    { to: "/notifiche", label: "Centro Notifiche", perm: "dashboard.read" },
  ] },
  { key: "clienti", label: "Clienti", icon: Users, children: [
    { to: "/clienti", label: "Elenco clienti", perm: "clients.read" },
    { to: "/importa", label: "Importa da altro gestionale", perm: "clients.write" },
    { to: "/loyalty", label: "Loyalty", perm: "loyalty.read" },
    { to: "/pacchetti", label: "Pacchetti & Gift Card", perm: "packages.read" },
  ] },
  { key: "team", label: "Team", icon: UserCog, children: [
    { to: "/team", label: "Membri · Turni · Presenze", perm: "team.read" },
    { to: "/obiettivi", label: "Obiettivi", perm: "goals.read" },
    { to: "/retribuzioni", label: "Retribuzioni", perm: "payroll.read" },
  ] },
  { key: "finanza", label: "Finanza", icon: Coins, to: "/prodotti", perm: "products.read" },
  { key: "marketing", label: "Marketing", icon: Megaphone, to: "/marketing", perm: "dashboard.read" },
  { key: "analisi", label: "Analisi", icon: FileBarChart, to: "/report", perm: "reports.read" },
  { key: "impostazioni", label: "Impostazioni", icon: Settings, children: [
    { to: "/servizi", label: "Servizi & Listino", perm: "services.read" },
    { to: "/impostazioni", label: "Impostazioni generali", perm: "settings.read" },
  ] },
];

// Azioni rapide globali (+ Nuovo). Navigano alla pagina relativa; filtrate per permessi.
export const QUICK_ACTIONS = [
  { to: "/agenda", label: "Nuovo appuntamento", perm: "agenda.write" },
  { to: "/clienti", label: "Nuova cliente", perm: "clients.write" },
  { to: "/cassa", label: "Nuova vendita", perm: "cassa.write" },
  { to: "/prodotti", label: "Carica fattura", perm: "warehouse.write" },
  { to: "/marketing", label: "Nuova campagna", perm: "dashboard.read" },
  { to: "/team", label: "Nuovo membro Team", perm: "team.read" },
];

export const ACQUISITION_SOURCES = [
  { value: "internet", label: "Internet" },
  { value: "facebook", label: "Facebook" },
  { value: "instagram", label: "Instagram" },
  { value: "tiktok", label: "TikTok" },
  { value: "amica", label: "Un'amica" },
  { value: "altro", label: "Altro" },
];
